import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ProductDetailNavigationState from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationState";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<ProductDetailNavigationState, DispatchProp<customerActions>>;

export const ResetLinks: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductDetailNavigation/ResetProductDetailNavigationState",
    });
};

export const chain = [ResetLinks];

const resetProductDetailNavigationState = createHandlerChainRunner(chain, "ResetProductDetailNavigationState");
export default resetProductDetailNavigationState;
